import { Box, CopyToClipboard, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { elevioApi } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/api';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../elevio.reducer/selectors';
import { buildArticleUrl } from '../../utils';

import styles from './CopyArticleLink.module.scss';

type CopyArticleLinkProps = {
  articleSlug: string;
};

/** Copy the URL of an article */
export function CopyArticleLink({
  articleSlug,
}: CopyArticleLinkProps): JSX.Element {
  const languageId = useAppSelector(
    elevioSelectors.suggestion.selectedLanguageId,
  );
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [isDisplayed, setIsDisplayed] = useState<boolean>(false);
  useEffect(() => {
    const copyTimeout = isCopied
      ? window.setTimeout(() => setIsCopied(false), 1500)
      : undefined;
    const displayTimeout = isCopied
      ? window.setTimeout(() => setIsDisplayed(false), 1400)
      : undefined;
    return () => {
      window.clearTimeout(copyTimeout);
      window.clearTimeout(displayTimeout);
    };
  }, [isCopied]);

  const { data } = elevioApi.datahub.useCompanySettingsQuery({});
  const kbUrl = data?.settings.kbUrl || '';
  if (!kbUrl) return <></>;

  const onClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    e.stopPropagation();
    setIsCopied(true);
    setIsDisplayed(true);
  };

  const articleUrl = buildArticleUrl({
    kbUrl,
    articleSlug,
    langCode: languageId,
  });

  return (
    <CopyToClipboard
      textToCopy={articleUrl}
      tooltip={false}
      clickedProps={{
        variant: 'primary',
        icon: 'done',
      }}
      onClick={onClick}
      disabled={false}
    >
      <Tooltip
        alwaysShow={isDisplayed}
        content={isCopied ? 'Copied' : 'Copy link'}
        side="top"
      >
        <Box height="16px">
          {isCopied ? (
            <Icon className={styles.doneIcon} name="check-circle-filled" />
          ) : (
            <Icon name="link" />
          )}
        </Box>
      </Tooltip>
    </CopyToClipboard>
  );
}
